export default {
  footer: {
    support1: {
      title: "شبكة موثوقة",
      desc: "مطاعم وموردون موثوقون",
    },
    support2: {
      title: "منصة متكاملة",
      desc: "الطلبات والتسعير والتتبع",
    },
    support3: {
      title: "دعم مخصص",
      desc: "نحن هنا لمساعدتك",
    },

    about:
      "MAHAL هي منصة B2B تربط المطاعم بالموردين الموثوقين لتوريد غذائي شفاف وفعال.",

    company: "الشركة",
    about_link: "حول MAHAL",
    how: "كيف يعمل",
    careers: "وظائف",
    contact: "اتصل بنا",

    platform: "المنصة",
    restaurants: "للمطاعم",
    suppliers: "للموردين",
    marketplace: "السوق",
    pricing: "الأسعار",

    resources: "الموارد",
    blog: "المدونة",
    faq: "الأسئلة الشائعة",
    support: "الدعم",
    terms: "الشروط والخصوصية",

    news: "ابقَ على اطلاع",
    news_desc:
      "احصل على تحديثات المنتج وأخبار المنصة مباشرة إلى بريدك.",
    email: "البريد الإلكتروني",

    copy: "© 2026 MAHAL. جميع الحقوق محفوظة.",
  },
};